  <template>
  <div class="Login">
    <v-container fill-height class="primary loginMain">
      <v-layout row wrap>
        <v-flex class="text-xs-center" xs12 sm12 md12 lg4 style="margin:auto">
          <!--<v-flex class="pa-1">-->
              <!-- <img class="logo" src="../../assets/logo2.png"> -->
                            <!-- <p class="headline font-weight-medium mb-3 text--lighten-1">Login</p> -->

            <!--</v-flex>-->
             <!--<v-progress-linear :indeterminate="loading" class="ma-0" color="secondary"></v-progress-linear>-->
          <div class="Formcard grey lighten-5 pb-5 card-r no-shadow">
            <div class="card-r no-shadow w-100 mb-5">
              <v-flex class="pt-1 mt-4 pt-5 ,">
              <!--<h1 class="display-1 font-weight-bold">Admin Login</h1>-->
              <img class="logo" src="/static/logo1.png">
              <!-- <h1 class="f-45 font-weight-bold">HeyWay</h1> -->
              <!-- <div class="f-15">Login</div> -->
            </v-flex>
            <v-form v-model="loginAdmin" row  @submit.prevent="login" class="w-100">
              <v-container xs12 md12 class="pa-0 mt-4">
                <v-layout wrap class="logBD">
                  <v-flex>
                                       <!-- <h1 class="headline font-weight-medium mb-3 text-xs-left">Login</h1> -->

                  </v-flex>
                  <v-flex xs12 sm12>
                    <v-text-field
                      v-model="email"
                      solo
                      label="Email"
                      :role="emailRules"
                      required
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm12 pb-0>
                    <v-text-field
                      solo
                      v-model="password"
                      label="Password"
                      :type="passwordShow ? 'text' : 'password'"
                      :append-icon="passwordShow ? 'visibility_off' : 'visibility'"
                      @click:append="passwordShow = !passwordShow"
                      :role="passwordRule"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md12 class="text-xs-right" py-0>
                    <router-link to="/resetpassword" class="aBtn text-xs-right">Reset your password</router-link>
                  </v-flex>
                  <v-flex xs12 sm12 pb-0 class="display-grid pa-0" >
                    <v-btn class="text-white h-50p primary card-r no-shadow white--text" color="white" type="submit">Login</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
             <v-snackbar v-if="error" :timeout="timeout" :top="true" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="error">
                  {{ text }}
                  <v-btn class="pink--text" flat @click.native="error = false">Close</v-btn>
            </v-snackbar>
          </div>
          </div>
        </v-flex>
      </v-layout>
      <!-- <notifications group="error" position="top center"/> -->
    </v-container>
  </div>
</template>

  <script>
/* eslint-disable */
import auth from '../../utils/auth'


export default {
  name: "Login",
  data: () => ({
    loginAdmin: true,
    email: "",
    password: "",
    passwordShow: false,
    error: false,
    text: '',
     mode: '',
        timeout: 6000,

    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    passwordRule: [
      v => !!v || "Password is required",
      v => v.length >= 8 || "Password must be more than 8 characters"
    ]
  }),
  validations:{
    // email:{
    //   required,
    // }
  },
  methods: {
    login() {
      let data = {
        email: this.email,
        password: this.password
      };
        auth.login(data, (loggedIn, err) => {
        if (err) {
          console.log('login', err)
          this.error = true
          this.text = "You have entered an invalid username or password"
        } else if (loggedIn === false) {
          console.log('login', loggedIn)
          this.error = true
          this.text = 'You have entered an invalid username or password'
        } else {
          console.log(this.$route)
          this.$router.push(this.$route.query.redirect || '/')
        }
      })

    },


  },
   computed:{
    loading(){
      // return this.$store.getters.loading
    },
      }
};
</script>
  <style>
    .align{
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-box;
    }
    .Formcard{
      height: -webkit-fill-available!important;
    }
  </style>



// WEBPACK FOOTER //
// src/pages/auth/Login.vue